import {Component, inject, Input} from '@angular/core';
import {AppointmentSelectionService} from '../../../appointment-selection/appointment-selection.service';
import {IconButtonComponent} from '../../../../shared/components/icon-button/icon-button.component';
import {DatePipe, Location} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MemoryService} from '../../../../core/services/memory.service';
import {LocalizedTextPipe} from '../../../../shared/pipes/localized-text.pipe';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {Router} from '@angular/router';
import {CustomDatePipe} from '../../../../shared/pipes/custom-date-pipe';

@Component({
  selector: 'app-selected-appointment',
  imports: [
    IconButtonComponent,
    MatIconModule,
    LocalizedTextPipe,
    TranslocoPipe,
    TextButton,
    CustomDatePipe
  ],
  templateUrl: './selected-appointment.component.html',
  styleUrl: './selected-appointment.component.scss'
})
export class SelectedAppointmentComponent {
  @Input() mobile = true;

  appointmentSelectionService = inject(AppointmentSelectionService);
  memoryService = inject(MemoryService);
  location = inject(Location);
  translocoService = inject(TranslocoService);
  router = inject(Router);

  get categoryName() {
    const categoryId = this.appointmentSelectionService.timeSlotDto?.categoryId;
    return this.appointmentSelectionService.categorySummaryDtos?.find(c => c.categoryId == categoryId)?.name;
  }

  get categoryPrice() {
    const categoryId = this.appointmentSelectionService.timeSlotDto?.categoryId;
    return this.appointmentSelectionService.categorySummaryDtos?.find(c => c.categoryId == categoryId)?.price;
  }

  get employee() {
    const employeeId = this.appointmentSelectionService.timeSlotDto?.employeeId;
    return this.appointmentSelectionService.employeeSummaryDtos?.find(e => e.employeeId == employeeId);
  }

  back() {
    this.location.back();
  }

  navigateToBooking() {
    if (!this.memoryService.patientId) {
      this.router.navigate(['/booking/login']);
      return;
    }

    this.router.navigate(['/booking/confirm']);
  }
}
